import {FAILURE, PENDING, SUCCESS, RESET} from '../../constants'
import {getEntities as getEntitiesAPI} from '../../../services/entities'

export async function getEntities(dispatch) {
  dispatch({type: PENDING})
  try {
    const response = await getEntitiesAPI()
    dispatch({type: SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Entities Failed: ${e}`)
    dispatch({type: FAILURE, payload: e})
  }
}

export async function setEntities(dispatch) {
  try {
    dispatch({type: RESET})
  } catch (e) {
    console.log(`reset Entities Failed: ${e}`)
    dispatch({type: FAILURE, payload: e})
  }
}
